import React, { useState, useEffect } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Table } from 'reactstrap';

const SearchPositionTrackerImportExcelTable = ({ reactTableData, data, customClass }) => {
   
  const [rowData, setData] = useState([]);
  // const [headerData, setHeaderData] = useState([]);
  const [isSortable, setIsSortable] = useState(false);
  const [isResizable, setIsResizable] = useState(true);
  const [withPagination, setWithPaginationTable] = useState(true);
  const [withSearchEngine, setWithSearchEngine] = useState(true);

  useEffect(() => {
    setData(data || []);
}, [data]);

  const currentDataByKeyword = {};
  const allDataData = {};
  const dataToPlot = [];

  rowData.forEach((item) => {
    if (item && currentDataByKeyword[item?.keyword]) {
        currentDataByKeyword[item?.keyword]?.push(item)
    } else if (item) {
        if (!item?.keyword || item?.keyword === 'null') {
            currentDataByKeyword?.['N/A']?.push(item)
        } else {
            currentDataByKeyword[item?.keyword] = [item]
        }
    }

    if (item && allDataData[item?.date]) {
        allDataData[item?.date]?.push(item)
    } else if (item) {
        if (!item?.date || item?.date === 'null') {
            allDataData?.['N/A']?.push(item)
        } else {
            allDataData[item?.date] = [item]
        }
    }
  }) 

  const currentKeyword = Object.keys(currentDataByKeyword);
  const dates = Object.keys(allDataData);
  
  const headerData = [{
    Header: 'Keyword',
    accessor: 'keyword',
    disableGlobalFilter: false,
  },
  {
    Header: 'Search Volume',
    accessor: 'searchVolume',
    disableGlobalFilter: false,
  },
  {
    Header: 'Keyword Sales',
    accessor: 'keywordSales',
    disableGlobalFilter: false,
  },
  {
    Header: 'Type',
    accessor: 'type',
    disableGlobalFilter: false,
  }];

  for (let index = 0; index < dates.length; index += 1) {
    const date = dates[index];
    headerData.push({
        // Header: moment(date).format('DD-MM').toString(),
        // accessor: moment(date).format('DD-MM').toString(),
        Header: date.toString(),
        accessor: date.toString(),
        disableGlobalFilter: false,
        // rightAlign: true,
        width: 100, 
        // sortType       
    })
    
  }
 
  const reduceCallback = (acc, currentRow) => {   
    if (acc[currentRow.date]) {
      acc?.[currentRow.date]?.push(currentRow)
    } else {
      acc[currentRow.date] = [currentRow]
    }    
    return acc
  }

  for (let index = 0; index < currentKeyword.length; index += 1) {
    const kWord = currentKeyword[index];
    const currentKeywordData = currentDataByKeyword?.[kWord] ?? [];    

    const searchVolumeSum = currentKeywordData.reduce((accum, item) => Number(Number(Number(accum) +
    (item.searchVolume === '-' ? 0  : Number(item.searchVolume)))), 0) ?? 0;
    const keywordSalesSum = currentKeywordData.reduce((accum, item) => Number(Number(Number(accum) +
    (item.keywordSales === '-' ? 0  : Number(item.keywordSales)))), 0) ?? 0;

    const dateWiseData = currentKeywordData?.reduce(reduceCallback, {})
    const dateWiseFinalData = Object.keys(dateWiseData).reduce((acc, currentDate) => {
        acc[currentDate] = {
            currentData: dateWiseData[currentDate]
        }
        return acc
    }, {})
    
    dataToPlot.push({
        keyword: kWord,
        searchVolume: searchVolumeSum.toString(),
        keywordSales: keywordSalesSum.toString(),
        type: {
            organicType: 'organic',
            sponsoredPosition: 'Sponsored Position'
        },
        dateWiseFinalData
    })
  }
  

  const updateEditableData = (rowIndex, columnId, value) => {
    setData(old => old.map((item, index) => {
      if (index === rowIndex) {
        return {
          ...old[rowIndex],
          [columnId]: value,
        };
      }
      return item;
    }));
  };

  const handleClickIsSortable = () => {
    setIsSortable(!isSortable);
  };

  const handleClickWithPagination = () => {
    setWithPaginationTable(!withPagination);
  };

  const handleClickIsResizable = () => {
    setIsResizable(!isResizable);
  };

  const handleClickWithSearchEngine = () => {
    setWithSearchEngine(!withSearchEngine);
  };

  const tableConfig = {
    isEditable: false,
    isResizable: true,
    isSortable: true,
    withPagination,
    withSearchEngine,
    manualPageSize: [250, 500, 1000, 1500, 2000],
    placeholder: 'Search by Title...',
  };


  const handleBackgroundColor = (value) => {
    let backgroundColor = 'white';
    const numericValue = parseInt(value, 10);
    if(numericValue > 0 && numericValue <= 10){
      backgroundColor = 'green';
    }
    else if (numericValue > 10 && numericValue <= 50){
      backgroundColor = 'yellowgreen';
    }
    else if (numericValue > 50 && numericValue <= 100){
      backgroundColor = 'yellow';
    }
    else if (numericValue > 100 && numericValue <= 150){
      backgroundColor = '#ffae42';
    }
    else if (numericValue > 150 && numericValue <= 200){
      backgroundColor = 'orange';
    }
    else if (numericValue > 200 && numericValue <= 250){
      backgroundColor = 'redorange';
    }
    else if (numericValue > 250) {
      backgroundColor = 'red';
    }
    return backgroundColor;
  }

  return (
    // <Col md={12} lg={12}>
      <Card>
        <CardBody className={`${customClass} pl-0 pr-0`}>
          <div style={{ overflowY: 'auto', maxHeight: '400px' }}>
            <Table responsive striped hover className="dashboard__table-orders" 
               width="100%" style={{overflowY: 'auto', maxHeight: '400px'}}>
                {/* <thead style={{ position: 'sticky', top: '0', zIndex: '1', background: 'white'}}> */}
                <thead>
                    <tr>
                        {headerData.map((item,index) => {
                           const thStyle = { minWidth: '250px' };
                           if (item?.Header === 'keyword') {
                               thStyle.minWidth = '150px';
                               thStyle.textAlign = 'left';
                               thStyle.position = 'sticky';
                               thStyle.left = '0';
                               thStyle.zIndex = '2';                               
                           } else if (item?.Header === 'searchVolume') {
                              thStyle.minWidth = '100px';
                              thStyle.textAlign = 'right';
                              thStyle.position = 'sticky';
                              thStyle.left = '100px';
                              thStyle.zIndex = '2';   
                           } else if (item?.Header === 'keywordSales') {
                              thStyle.minWidth = '100px';
                              thStyle.textAlign = 'right';
                              thStyle.position = 'sticky';
                              thStyle.left = '200px';
                              thStyle.zIndex = '1';   
                           } else if (item?.Header === 'type') {
                              thStyle.minWidth = '100px';
                              thStyle.textAlign = 'left';
                              thStyle.position = 'sticky';
                              thStyle.left = '300px';
                              thStyle.zIndex = '1';   
                           } else {
                               thStyle.minWidth = '50px';
                               thStyle.width = "50px"
                               thStyle.textAlign = 'right';
                           }
                          //  style={{ position: 'sticky', left: 0, zIndex: 1, background: 'white' }}
                           return (
                               <th style={{thStyle}}>
                                   {index > 3 ? 
                                    moment(item?.Header).format('DD-MM')
                                    : item?.Header}
                               </th>
                           );
                            
                        })}
                    </tr>
                </thead>
                <tbody>
                    {dataToPlot?.length ? dataToPlot?.map(item => (
                        <tr style={{backgroundColor: 'ye'}}>
                            <td 
                                style={{ 
                                    // paddingTop: '4px', 
                                    // paddingBottom: '4px',
                                    // width: '250px',
                                    minWidth: '150px',
                                    textAlign: 'left',
                                    verticalAlign: 'middle',
                                    position: 'sticky',
                                    left: '0',
                                    zIndex: '2',
                                    backgroundColor: 'white'
                                }} 
                                // rowSpan={2}
                            >
                                {item.keyword}
                            </td>
                            <td 
                                style={{ 
                                    // paddingTop: '4px', 
                                    // paddingBottom: '4px', 
                                    minWidth: '100px',
                                    textAlign: 'right',
                                    verticalAlign: 'middle',
                                    position: 'sticky',
                                    left: '150px',
                                    zIndex: '2',
                                    backgroundColor: 'white'
                                  }} 
                                // rowSpan={2}
                            >
                                {item.searchVolume}
                            </td>
                            <td 
                                style={{ 
                                    // paddingTop: '4px', 
                                    // paddingBottom: '4px',
                                    minWidth: '100px',
                                    textAlign: 'right',
                                    verticalAlign: 'middle',
                                    position: 'sticky',
                                    left: '300px',
                                    zIndex: '2',
                                    backgroundColor: 'white'
                                }} 
                               
                                // rowSpan={2}
                            >
                                {item.keywordSales}
                            </td>                            
                            <td style={{ 
                              // paddingTop: '4px', 
                              // paddingBottom: '4px', 
                                minWidth: '100px',
                                position: 'sticky',
                                textAlign: 'left',
                                left: '450px',
                                zIndex: '2', 
                                backgroundColor: 'white'
                              }}
                            >
                                <tr>
                                  <td>
                                  {item?.type?.organicType}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                  {item?.type?.sponsoredPosition}
                                  </td>
                                </tr>
                                    {/* <span>{item?.type?.organicType}</span><br/>
                                    <span>{item?.type?.sponsoredPosition}</span> */}
                                
                            </td>
                            {headerData.map((header, index) => (
                                index > 3 ? (
                                    <td
                                      style={{ 
                                        // paddingTop: '4px', 
                                        // paddingBottom: '4px' ,
                                        // minWidth: '150px'
                                      }}
                                    //   key={index} // Add a unique key for React
                                    >
                                      <tr >
                                        <td
                                          style={{
                                            backgroundColor:
                                            handleBackgroundColor(item?.dateWiseFinalData?.
                                              [header?.Header]?.
                                              currentData[0]?.organicRank),
                                            color: 
                                              item?.dateWiseFinalData?.
                                              [header?.Header]?.currentData[0]
                                              ?.sponsoredPosition
                                              === '-' ? 'black' : 'black',                                            
                                          }}
                                        >
                                        {item?.dateWiseFinalData?.[header?.Header]?.currentData[0]?.organicRank}
                                        </td>
                                      </tr>
                                      <tr style={{ marginTop: '10px' }}>
                                        <td
                                          style={{
                                            backgroundColor: 
                                            handleBackgroundColor(item?.dateWiseFinalData?.
                                              [header?.Header]?.
                                              currentData[0]?.sponsoredPosition),
                                            color: 
                                            item?.dateWiseFinalData?.[header?.Header]?.currentData[0]?.sponsoredPosition
                                            === '-' ? 'black' : 'black'                                    
                                          }}
                                        >
                                        {item?.dateWiseFinalData?.[header?.Header]?.currentData[0]?.sponsoredPosition}
                                        </td>
                                      </tr>                                      
                                    </td>
                                  ) : null
                            ))}
                        </tr>
                    )) : 'No data to display'}
                </tbody>
            </Table>
          </div>
          {/* <ReactTableBase
            key={withSearchEngine ? 'searchable' : 'common'}
            columns={reactTableData.tableHeaderData}
            data={[]}
            // data={dataToPlot}
            tableConfig={tableConfig}
          /> */}
        </CardBody>
      </Card>
    // </Col>
  );
};

SearchPositionTrackerImportExcelTable.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  customClass: PropTypes.string,
};

SearchPositionTrackerImportExcelTable.defaultProps = {
  customClass: ''
}

export default SearchPositionTrackerImportExcelTable;
